import { ComponentPropsWithoutRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { Address, DataHygieneAddressDataDetails } from 'types/domain';

interface AddressReadableProps extends Omit<ComponentPropsWithoutRef<'div'>, 'children'> {
    address: Address | DataHygieneAddressDataDetails;
}

const AddressReadable = (props: AddressReadableProps) => {
    const { address, className, ...rest } = props;
    return (
        <div className={twMerge('flex flex-col', className)} {...rest}>
            <p className={'text-sm'}>{address.address_1}</p>
            {address.address_2 && <p className={'text-sm'}>{address.address_2}</p>}
            <p className={'text-sm'}>
                {address.city}
                {address.state && `, ${address.state}`}
                {address.country && `, ${address.country}`}
                {address.zipcode && ` ${address.zipcode}`}
            </p>
        </div>
    );
};

const copyAddress = (address: Address) => {
    let result =
        address.address_1 +
        (address.address_2 ? `\n${address.address_2}` : '') +
        `\n${address.city}` +
        (address.state ? `, ${address.state}` : '') +
        (address.country ? `, ${address.country}` : '') +
        (address.zipcode ? ` ${address.zipcode}` : '');

    return result;
};

export { AddressReadable, copyAddress };
export type { AddressReadableProps };
